/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CollaboratorPage = lazyLoad(
  () => import('./index'),
  module => module.CollaboratorPage
);
